module.exports = __webpack_public_path__ + "ui-static/img/export-border-right.22a58772.svg";